import { Routes } from '@angular/router';
import { authGuard, guestGuard, roleGuard } from 'app/core';
import { ErrorPageComponent } from './features/error/ui/error-page';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'session/login',
    pathMatch: 'full',
  },
  {
    path: 'session',
    loadChildren: () => import('./features/session/session.routes').then((m) => m.sessionRoutes),
    canActivate: [guestGuard],
  },
  {
    path: 'admin',
    loadChildren: () => import('./features/admin/admin.routes').then((m) => m.adminRoutes),
    canActivate: [roleGuard(['HR_ADMIN', 'OPS_ADMIN'])],
  },
  {
    path: 'cv',
    loadChildren: () => import('./features/cv/cv.routes').then((m) => m.cvRoutes),
  },
  {
    path: 'home',
    loadChildren: () => import('./features/home/home.routes').then((m) => m.adminRoutes),
    canActivate: [authGuard],
  },
  {
    path: '**',
    component: ErrorPageComponent,
  },
];
